/**
 * Device Detection Utilities
 * Detects device type and platform for smart app banner display
 */

/**
 * Check if user is on Android device
 * @returns {boolean}
 */
export const isAndroid = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /android/i.test(userAgent);
};

/**
 * Check if user is on iOS device
 * @returns {boolean}
 */
export const isIOS = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
};

/**
 * Check if user is on mobile device
 * @returns {boolean}
 */
export const isMobile = () => {
    return isAndroid() || isIOS();
};

/**
 * Check if user is on tablet
 * @returns {boolean}
 */
export const isTablet = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent);
};

/**
 * Get device type
 * @returns {'android' | 'ios' | 'desktop'}
 */
export const getDeviceType = () => {
    if (isAndroid()) return 'android';
    if (isIOS()) return 'ios';
    return 'desktop';
};

/**
 * Check if app is likely installed
 * This is a best-effort check, not 100% accurate
 * @returns {boolean}
 */
export const isAppLikelyInstalled = () => {
    // We can't reliably detect if app is installed from web
    // This will be determined by the deep link attempt
    return false;
};
